export default __webpack_public_path__ + "static/media/main-banner2.aba3f34c.jpg";